export default "__VITE_ASSET__CFt0sA3t__"